import { getMultiProfileFeature, getOpenCatalogFeature } from '../features/features.selectors';
import { getCurrentLayout } from '../layout/layout.selectors';
import { getPairingStatus, getSelectedProfile } from '../pairing/pairing.selectors';
import { STATUS_PAIRED } from '../pairing/pairing.utils';
import { getMatchingSkeleton } from './routing.utils';

export const ROUTING_LOCATION_CHANGE = 'routing/LOCATION_CHANGE';

export const ROUTING_SAVE_DEEPLINK = 'routing/SAVE_DEEPLINK';

export const ROUTING_SET_IS_TOP_LEVEL_ROUTE = 'routing/SET_IS_TOP_LEVEL_ROUTE';

export const LANDING_SHOWN = 'routing/ROUTING_SET_IS_LANDING_SHOWN';

export const SHOULD_DISPLAY_LANDING = 'routing/SHOULD_DISPLAY_LANDING';

export const SET_ROUTE_SKELETON = 'routing/SET_ROUTE_SKELETON';

export const setDeeplinkLocation = deeplink => ({ type: ROUTING_SAVE_DEEPLINK, deeplink });

/**
 * @param {string} location current router path string
 * @param {string} path current router path template
 */
export const setCurrentLocation = (location, path) => ({ type: ROUTING_LOCATION_CHANGE, location, path });

export const setIsTopLevelRoute = isTopLevelRoute => ({ type: ROUTING_SET_IS_TOP_LEVEL_ROUTE, isTopLevelRoute });

export const landingShown = () => ({ type: LANDING_SHOWN });

export const landingShouldBeShown = () => ({ type: SHOULD_DISPLAY_LANDING });

export const setRouteSkeleton = skeleton => ({ type: SET_ROUTE_SKELETON, skeleton });

export const hideRouteSkeleton = () => ({ type: SET_ROUTE_SKELETON, skeleton: null });

// eslint-disable-next-line no-unused-vars
export const setRouteSkeletonByEntity = (entityType, entityId) => async (dispatch, getState) => {
  const state = getState();
  const currentLayout = getCurrentLayout(state);
  const hasProfiles = getMultiProfileFeature(state);
  const isOpenCatalog = getOpenCatalogFeature(state) && getPairingStatus(state) !== STATUS_PAIRED;
  const selectedProfileUid = getSelectedProfile(state);
  const isProfileSelected = hasProfiles ? Boolean(selectedProfileUid) : true;

  // NOTE: Handling possible profiles gate
  if (currentLayout || (!isOpenCatalog && !isProfileSelected)) {
    dispatch(setRouteSkeleton());
  } else {
    dispatch(setRouteSkeleton(getMatchingSkeleton(entityType, entityId)));
  }
};
